import { useEffect } from "react";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";
import { toastState } from "atoms";
import { useRecoilState } from "recoil";

const Toaster = () => {
  const [toast, setToast] = useRecoilState(toastState);
  useEffect(() => {
    if (toast.show) {
      setTimeout(() => {
        setToast({
          ...toast,
          show: false,
          variant: "",
          header: "",
          message: "",
        });
      }, 5000);
    }
  }, [toast, setToast]);
  return (
    <ToastContainer position='top-center'>
      <Toast className='toaster-container' show={toast.show} bg={toast.variant} onClose={() => setToast({ ...toast, show: false })}>
        <Toast.Body>
          {" "}
          <div className='d-flex p-2'>
            <div>{toast.message} </div>
            <i
              className='fa-solid fa-xmark-large'
              onClick={() =>
                setToast({
                  ...toast,
                  show: false,
                  variant: "",
                  header: "",
                  message: "",
                })
              }></i>
          </div>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default Toaster;
